<script setup lang="ts">
import type { LocationCollectionItem } from '@nuxt/content'

import { CustomMarker } from 'vue3-google-map'

const props = defineProps<{
  location: LocationCollectionItem
}>()

const { isActive } = useLocation(props.location)!

const markerOptions = computed<google.maps.CustomMarkerOptions>(() => {
  return {
    position: {
      lat: props.location.position.lat,
      lng: props.location.position.lng,
    },
    zIndex: isActive.value ? 1 : 0,
    anchorPoint: 'TOP_CENTER',
  }
})
</script>

<template>
  <CustomMarker :options="markerOptions">
    <LocationsMapMarkerPin :location="props.location" />
  </CustomMarker>
  <CustomMarker v-if="isActive" :options="markerOptions">
    <LocationsMapMarkerWindow :location="props.location" />
  </CustomMarker>
</template>
